import {useState} from 'react';

import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid'

import Dialog from '@base/Dialog';
import {ButtonDefault, ButtonPrimary} from '@base/Button/Button';
import ArmazenarTableView from "./ArmazenarTableView";

export const ArmazenarCaixaDialog = (props) => {
  const [loading, ] = useState(false);
  const [filtroAtivo, setFiltroAtivo] = useState(false);

  const actions = () => {
    return (
      <>
        <ButtonPrimary
          disabled={loading}
          onClick={props.handleConfirm}
          startIcon={loading ? <CircularProgress size={16}/> : <CheckOutlinedIcon/>}
          style={{margin: 4}}
          name="Confirmar"
        />
        <ButtonDefault
          onClick={props.close}
          startIcon={<ClearOutlinedIcon/>}
          style={{margin: 4}}
          name="Cancelar"
        />
      </>
    )
  }

  return (
    <>
      <Dialog
        openDialog={props.open}
        title={props.title}
        closeDialog={props.close}
        actions={actions()}
        fullWidth={true}
        maxWidth={props.maxWidth ?? "md"}
      >
        <Grid alignItems="center" container spacing={2}>
            <ArmazenarTableView
              processo={props.processo}
              caixaCodigo={props.caixaCodigo}
              filtros={[{field: 'codigoCaixa', value: props.caixaCodigo},
                {field: 'dataArmazenamento', value: "false"}]}
              filtroAtivo={filtroAtivo}
              setFiltroAtivo={setFiltroAtivo}
              dialog={true}
            />

        </Grid>
      </Dialog>
    </>
  )
}

export default ArmazenarCaixaDialog;
